<template lang="pug">
    v-card(v-if="parameter")
        v-card-title(class="primary--text title-text" style="border-radius: 5px 5px 0px 0px;" dense) Panduan
            v-spacer
            v-icon(color="primary") mdi-book-open-variant
        v-divider
        v-card-text
            div(v-html="parameter" style="font-size:12px")
</template>
<script>
export default {
  name: "FGuideCard",
  props: ["value","getParam"],
  data() {
    return {
      guide: null,
      parameter: ""
    };
  },
  mounted() {
    this.doInitModel(this.value);
  },
  watch: {
    value(val) {
      this.doInitModel(val);
    }
  },
  methods: {
    doInitModel(value) {
      this.guide = value ? value : null;
      this.getParam ? this.getParameter() : (this.parameter = this.guide) ;
    },
    getParameter() {
      this.parameter = ""  ;
    }
  }
};
</script>